module.exports = {
    heartland_api: 'pkapi_cert_wcN2EUGynhQXaEP9xx',
    domain:'leasera.com' ,
    searchWebsiteUri: 'https://leasera.com',
    renterPortalUri: 'https://renter.leasera.com',
    managerPortalUri:  'https://manager.leasera.com',
    GRAPHQL_URL: '/graphql',
    SENTRY_URL: 'https://8375c4f116af410382124b89d8ffcbf5@sentry.io/1318669',
  }